import { useCallback } from "react";

import {
  type LiveAnalyticsCopilotOpenSource,
  tracker,
  trackingEvents,
} from "src/instrumentation/customTrackingEvents";
import { FlowPageParams } from "src/router/urls";
import { useParamsDecode } from "src/utils/useParamsDecode";

type TrackCopilotOpened = (source: LiveAnalyticsCopilotOpenSource) => void;

export const useTrackCopilotOpened = (): TrackCopilotOpened => {
  const { flow_id, orgId, wsId } = useParamsDecode<FlowPageParams>();

  return useCallback(
    (source: LiveAnalyticsCopilotOpenSource) =>
      tracker.emit(
        trackingEvents.liveAnalyticsCopilotOpened({
          organization_id: orgId,
          workspace_id: wsId,
          flow_id,
          source,
        }),
      ),
    [orgId, wsId, flow_id],
  );
};
